import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PricingSection = () => {
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useState("");
  const [pricingData, setPricingData] = useState({
    currencySymbol: "",
    bronzePlanPrice: "",
    bronzePlanId: "",
    silverPlanPrice: "",
    silverPlanId: "",
    goldPlanPrice: "",
    goldPlanId: "",
    oneTimeSetupFee: "",
  });

  // Constants for US and India pricing
  const US_PRICING = {
    bronzePlanPrice: "200.00",
    bronzePlanId: "1",
    silverPlanPrice: "300.00",
    silverPlanId: "2",
    goldPlanPrice: "99.00",
    goldPlanId: "4",
    oneTimeSetupFee: "349.00",
    currencySymbol: "$",
  };

  const IN_PRICING = {
    bronzePlanPrice: "3500.00",
    bronzePlanId: "21",
    silverPlanPrice: "5000.00",
    silverPlanId: "22",
    goldPlanPrice: "6000.00",
    goldPlanId: "24",
    oneTimeSetupFee: "6500.00",
    currencySymbol: "₹",
  };

  useEffect(() => {
    // Fetch visitor's IP and country info using ip-api service
    const getCountryCode = async () => {
      try {
        
        // const response = await fetch("https://ipapi.co/json/");
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();
        const country = data.country_code;
       
        // const response = await axios.get("http://ip-api.com/json/");
        // const country = response.data.countryCode;
        setCountryCode(country);

        if (country === "IN") {
          setPricingData(IN_PRICING);
        } else {
          setPricingData(US_PRICING);
        }
      } catch (error) {
        // toast.error("Error fetching country code", error);
        setPricingData(US_PRICING); // Default to US pricing
      }
    };

    getCountryCode();
  }, []);

  // Destructure the pricing data
  const {
    currencySymbol,
    bronzePlanPrice,
    bronzePlanId,
    silverPlanPrice,
    silverPlanId,
    goldPlanPrice,
    goldPlanId,
    oneTimeSetupFee,
  } = pricingData;

  const handlePricing = async (planId, planPrice, currencySymbol,planName) => {
    navigate('/register', {
      state: {
        planId: planId,
        planPrice: planPrice,
        currencySymbol: currencySymbol,
        planName:planName
      },
    });
  };

  return (
    <section className="section-grey" id="pricing">
      <ToastContainer />
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center padding-bottom-40">
            <h2 className="section-title">Pricing for every business, at any stage</h2>
            <p className="setup-fee">
              All Plans have a one-time setup fee: <b>{currencySymbol}{parseFloat(oneTimeSetupFee).toFixed(2)}</b>
            </p>
            <p className="section-subtitle">** 12 Months contract required for each plan.</p>
          </div>

          {countryCode === "IN" ? (
            <>
              {/* India Pricing Plans */}
              <div className="col-md-4">
                <div className="price-box">
                  <ul className="pricing-list">
                    <li className="price-title">BRONZE</li>
                    <li className="price-value">
                      {currencySymbol}
                      {parseFloat(bronzePlanPrice).toFixed(2)}
                    </li>
                    <li className="price-subtitle">Per Month</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Android and iOS Customized App</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Product (Add, Update)</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Upto 15 Products Supported</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> In City & Out of City Delivery Support</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Order History and Status Change</li>
                    <li className="price-text">
                      <i className="fas fa-check blue mtr-75"></i> Payment Gateway Support
                    </li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Email & Text Notification</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Email Support</li>
                    <li className="price-tag-line">
                      <a
                        onClick={() => handlePricing(bronzePlanId, bronzePlanPrice, currencySymbol,'BRONZE')}
                      >
                        SELECT PLAN
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Silver Plan */}
              <div className="col-md-4">
                <div className="price-box">
                  <div className="ribbon blue"><span>Popular</span></div>
                  <ul className="pricing-list">
                    <li className="price-title">SILVER</li>
                    <li className="price-value">
                      {currencySymbol}
                      {parseFloat(silverPlanPrice).toFixed(2)}
                    </li>
                    <li className="price-subtitle">Per Month</li>
                    <li className="price-text strong"><i className="fas fa-check blue mtr-75"></i><strong>Responsive website +</strong></li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Android and iOS Customized App</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Upto 25 Products Supported</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> In City & Out of City Delivery Support</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Order History and Status Change</li>
                    <li className="price-text">
                      <i className="fas fa-check blue mtr-75"></i> Payment Gateway Support
                    </li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Email & Text Notification</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Email Support</li>
                    <li className="price-tag-line">
                    <a
                        onClick={() => handlePricing(silverPlanId, silverPlanPrice, currencySymbol,'SILVER')}
                      >
                        SELECT PLAN
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Gold Plan */}
              <div className="col-md-4">
                <div className="price-box">
                  <ul className="pricing-list">
                    <li className="price-title white-text">GOLD</li>
                    <li className="price-value white-text">
                      {currencySymbol}
                      {parseFloat(goldPlanPrice).toFixed(2)}
                    </li>
                    <li className="price-subtitle white-text">Per Month</li>
                    <li className="price-text white-text"><i className="fas fa-check blue mtr-75"></i><strong>All Standard Features</strong></li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Android and iOS Customized App</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Upto 50 Products Supported</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> In City & Out of City Delivery Support</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Order History and Status Change</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Payment Gateway Support</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Email & Text Notification</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Email Support</li>
                    <li className="price-tag-line">
                    <a
                        onClick={() => handlePricing(goldPlanId, goldPlanPrice, currencySymbol,'GOLD')}
                      >
                        SELECT PLAN
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </>
          ) : (
            <>
              {/* US Pricing Plans */}
              <div className="col-md-2"></div>
              <div className="col-md-4">
                <div className="price-box">
                  <ul className="pricing-list">
                    <li className="price-title">BRONZE</li>
                    <li className="price-value">
                      {currencySymbol}
                      {parseFloat(bronzePlanPrice).toFixed(2)}
                    </li>
                    <li className="price-subtitle">Per Month</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Android and iOS Customized App</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Menu (Add, Update, Special Menu)</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Order History and Status Change</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Stripe Payment support</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Email & Text Notification</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Email Support</li>
                    <li className="price-tag-line">
                    <a
                        onClick={() => handlePricing(bronzePlanId, bronzePlanPrice, currencySymbol,'BRONZE')}
                      >
                        SELECT PLAN
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-4">
                <div className="price-box">
                  <div className="ribbon blue"><span>Popular</span></div>
                  <ul className="pricing-list">
                    <li className="price-title">SILVER</li>
                    <li className="price-value">
                      {currencySymbol}
                      {parseFloat(silverPlanPrice).toFixed(2)}
                    </li>
                    <li className="price-subtitle">Per Month</li>
                    <li className="price-text strong"><i className="fas fa-check blue mtr-75"></i><strong>Responsive website +</strong></li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Android and iOS Customized App</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Integration with POS Systems</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Order notification on POS</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Direct payment</li>
                    <li className="price-text"><i className="fas fa-check blue mtr-75"></i> Printer for orders</li>
                    <li className="price-tag-line">
                    <a
                        onClick={() => handlePricing(silverPlanId, silverPlanPrice, currencySymbol,'SILVER')}
                      >
                        SELECT PLAN
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-2"></div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
